import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import styles from "./MoreInfoAccordion.module.scss";
import { GradingHelp } from "../types";

type Props = {
  gradingHelps: GradingHelp[];
};
const MoreInfoAccordion = ({ gradingHelps }: Props) => {
  if (!gradingHelps.length) return null;

  return (
    <Accordion label="More information" className={styles.moreInfo} animated>
      {gradingHelps.map((help, index) => {
        return (
          <div
            key={`heading${index}${help.heading}`}
            className={styles.moreInfo__info}
          >
            <p className={styles.moreInfo__heading}>{help.heading}</p>
            <ul className={styles.moreInfo__list}>
              {help.points.map((copy, i) => (
                <li
                  className={styles.moreInfo__listItem}
                  key={`point${index}${i}`}
                >
                  {copy}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </Accordion>
  );
};
export default MoreInfoAccordion;
